import React, { Component } from 'react';
import { Redirect } from 'react-router';
import Version from "version";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from '@material-ui/core/Slide';
import Button from "components/CustomButtons/Button";
import ButtonX from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import ReactLoading from 'react-loading';
import Icon from "../components/Selfcare/Common/Icon";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import pricingPageStyle from "assets/jss/material-dashboard-pro-react/views/pricingPageStyle";

import { withTranslation } from 'react-i18next';
import compose from 'recompose/compose';

// dotNetify
import dotnetify from 'dotnetify';

import auth from "../auth";
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

var reactPlugin = new ReactPlugin();

const MySwal = withReactContent(Swal);

class PrepaidTopup extends Component {
    constructor(props) {
        super(props);
        this.vm = dotnetify.react.connect("PrepaidTopup", this, {
            headers: {
                Authorization: "Bearer " + auth.getAccessToken(),
                ClientVersion: Version.getVersion(),
                ServerToken: window.sessionStorage.ServerToken
            },
            exceptionHandler: _ => auth.signOut()
        });
        // Set up function to dispatch state to the back-end.
        this.dispatchState = state => this.vm.$dispatch(state);

        // we use this to make the card to appear after the page has been rendered
        this.state = {
            show: false,
            redirect: null,
            toUrl: null,
            Packages: null,
            ChangePriceplanDialogOpen: false,
            OrderSent: false,
            OrderError: '',
            OrderOpen: '',
            DisableButtons: false,
            buzy: false,
            canbuy: false,
            Loading: true,
            password: '',
            EnterPasswordDialogOpen: false,
        };
    }
    componentDidMount() {
        setTimeout(
            function () {
                this.setState({ show: true });
            }.bind(this),
            700
        );
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (nextState.OrderSent && !this.state.OrderSent) {
            this.setState({ Processing: false });
            MySwal.fire({
                title: 'Takk!',
                html: this.props.t('selfcare:notification.thank-you-ordering-datapacket'),
                icon: 'success',
                confirmButtonColor: '#e91e63',
            }).then((result) => {
                this.setState({ redirect: true, toUrl: '/overview' });
            });
        }
        if (nextState.OrderError && !this.state.OrderError) {
            MySwal.fire({
                title: this.props.t('selfcare:notification.order-failed'),
                html: nextState.OrderError,
                icon: 'error',
                confirmButtonColor: '#e91e63',
            }).then((result) => {
                this.dispatchState({ OrderError: null, OrderOpen: false });
                this.setState({ Processing: false, OrderError: null, OrderOpen: false });
            });
        }

    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
        this.vm.$destroy();
    }
    handleConfirmChangePackageDialogClose = () => {
        this.dispatchState({
            PerformChange: { SelectedPackageNo: this.state.SelectedPackage.PackageNo }
        });
        this.setState({ ChangePriceplanDialogOpen: false, buzy: true });
    }
    handleChange = name => event => {
        this.dispatchState({ [name]: event.target.checked, ClearErrors: true });
    }

    handleChangePriceplanDialogClose = () => {
        this.setState({ ChangePriceplanDialogOpen: false, SelectedPackage: null, error: null });
    }

    handleEnterPasswordDialogClose = () => {
        this.dispatchState({ EnterPasswordDialogOpen: false });
    }

    handleInputChange = name => event => {
        this.setState({ [name]: event.target.value, PasswordErrorText: '' });
    };

    hideAlert = () => {
        this.setState({
            alert: null, buzy: false, OrderError: '', OrderSent: false
        });
    }

    navigateTo = url => {
        this.setState({ show: false });
        setTimeout(
            function () {
                this.setState({
                    toUrl: url,
                    redirect: true
                });
            }.bind(this),
            300
        );
    }

    handleChange = event => {
        this.setState({ value: event.target.value, canbuy: true });
    };
    render() {
        console.debug('PostpaidTopup render');
        const classes = this.props;
        const { t } = this.props;
        return (
            <div style={{ height: '100vh' }}>
                {this.state.redirect ? <Redirect to={this.state.toUrl} /> : null}
                <Dialog
                    open={this.state.EnterPasswordDialogOpen}
                    onClose={() => { this.setState({ EnterPasswordDialogOpen: false, buzy: false }); }}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">
                        <div style={{ display: 'flex' }}>
                            <Icon name="edit" size={36} color="#e91e63" />
                            <span style={{ marginLeft: '20px', fontWeight: '700' }}>{t('selfcare:title.code-set-by-legal-owner')}</span>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        {this.state.PasswordText}<br />
                        <TextField
                            style={{ width: '100%' }}
                            id="password"
                            label={t('selfcare:label.code')}
                            type="password"
                            value={this.state.password}
                            onChange={this.handleInputChange('password')}
                            margin="normal"
                        />
                        {this.state.PasswordErrorText && <div style={{ width: '100%', padding: '5px', backgroundColor: '#e91e63', color: 'white', fontSize: '12px' }}>{this.state.PasswordErrorText}</div>}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { this.dispatchState({ SetPassword: this.state.password }); }} color="rose">
                            {t('selfcare:button.proceed-uc')}
                        </Button>
                        <Button onClick={() => { this.setState({ EnterPasswordDialogOpen: false, buzy: false }); }}>
                            {t('selfcare:button.cancel-uc')}
                        </Button>
                    </DialogActions>
                </Dialog>
                {this.state.IsAdministrating && <div style={{ backgroundColor: 'black', color: 'white', height: '50px', paddingLeft: '5px', textAlign: 'center', borderBottom: '1px grey solid' }}><span dangerouslySetInnerHTML={{ __html: t('selfcare:info.now-administrating-number', { 0: this.state.AdministratedMsisdn }) }} /><br /><a style={{ color: 'white' }} href='/overview' onClick={(e) => { sessionStorage.stopAdmin = this.state.LoggedInMsisdn; this.navigateTo('/overview'); e.preventDefault(); }}>{t('selfcare:button.back-to-logged-in-user')}</a></div>}
                <Slide direction="down" in={this.state.show} mountOnEnter unmountOnExit>
                    <div style={{ backgroundColor: '#e91e63', color: '#FFF', padding: '20px' }}>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={10} md={8} lg={6} xl={4} >
                                <Icon name="money" size={48} color="#FFFFFF"/>
                                <div style={{ fontSize: '20px', fontWeight: '700', maxWidth: '900px' }}>
                                    {t('selfcare:item.datapacket-chili-prepaid')}
                                </div>
                                <div style={{ fontSize: '14px' }}>
                                    <span dangerouslySetInnerHTML={{ __html: t('selfcare:info.datapacket-description') }} />
                                </div>
                            </GridItem>
                        </GridContainer>
                    </div>
                </Slide>
                <Slide direction="up" in={this.state.show} mountOnEnter unmountOnExit>
                    <form onSubmit={(e) => { e.preventDefault(); this.setState({ Processing: true }); this.dispatchState({ PerformChange: { SelectedProductNo: this.state.value } }); }}>
                        <GridContainer direction="column" justify="center" alignItems="center">
                            <GridItem>
                                <div style={{paddingTop: '20px'}}>
                                    {t('selfcare:item.choose-datapacket')}
                                </div>    
                            </GridItem>
                            <GridItem>
                                {this.state.Loading && <ReactLoading type={"bubbles"} color={"#e91e63"} height={'50px'} width={'50px'} />}
                            </GridItem>
                            <GridItem>
                                <FormControl component="fieldset" className={classes.formControl}>
                                    <RadioGroup
                                        aria-label={t('selfcare:label.datapackets')}
                                        name="data"
                                        className={classes.group}
                                        value={this.state.value}
                                        onChange={this.handleChange}
                                    >
                                        {this.state.TopUps ? this.state.TopUps.map((option) => {
                                            return (
                                                <FormControlLabel key={option.ProductNo} value={option.ProductNo} control={<Radio />} label={option.Description} style={{ fontWeight: 700 }}/>
                                            );
                                        }) : null}
                                    </RadioGroup>
                                </FormControl>
                            </GridItem>
                            <GridItem>
                                {t('selfcare:item.datapacket-duration')}
                            </GridItem>
                            <GridItem>
                                    <GridContainer justify="center" direction="row">
                                        <GridItem>
                                            <div style={{ paddingTop: '20px', width: '250px' }}>
                                                {this.state.buzy && <CircularProgress size={48} style={{
                                                    color: '#C2185B', position: 'absolute',
                                                    top: '20%',
                                                    left: '50%',
                                                    marginTop: -12,
                                                    marginLeft: -12,
                                                }} />}
                                            <Button size="sm" type="submit" disabled={!this.state.canbuy || this.state.OrderOpen || this.state.Processing} style={{ borderRadius: '19px', marginRight: '10px' }} variant="contained" color="rose">{t('selfcare:button.confirm-purchase')}</Button>
                                            <ButtonX size="small" id='cancel' onClick={() => { this.navigateTo('/overview'); }}>{t('selfcare:button.cancel')}</ButtonX>
                                        </div>
                                        {this.state.Processing && <ReactLoading type={"bubbles"} color={"#e91e63"} height={'50px'} width={'50px'} />}
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                    </form>
                </Slide>
            </div>
        );
    }
}
PrepaidTopup.propTypes = {
};

export default compose(
    withStyles(pricingPageStyle),
    withTranslation(),
)(withAITracking(reactPlugin, PrepaidTopup));